var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2568 0.372008C10.8662 -0.0185167 10.2331 -0.0185168 9.84256 0.372008L5.88477 4.3298L1.92697 0.372007C1.53645 -0.0185171 0.903283 -0.0185177 0.512759 0.372007L0.372004 0.512761C-0.0185201 0.903286 -0.0185205 1.53645 0.372004 1.92698L4.3298 5.88477L0.371999 9.84257C-0.0185255 10.2331 -0.0185259 10.8663 0.371998 11.2568L0.512753 11.3975C0.903277 11.7881 1.53644 11.7881 1.92697 11.3975L5.88477 7.43974L9.84256 11.3975C10.2331 11.7881 10.8663 11.7881 11.2568 11.3975L11.3975 11.2568C11.7881 10.8663 11.7881 10.2331 11.3975 9.84257L7.43973 5.88477L11.3975 1.92698C11.7881 1.53645 11.7881 0.903286 11.3975 0.512763L11.2568 0.372008Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.6c7c064c588d38d94c69c776c3fd2991.svg";
export { ForwardRef as ReactComponent };